<template>
    <div class="pb-3">
        <description-xs />
        <upload-photos />
    </div>
</template>

<script>
import DescriptionXs from '../components/DescriptionXs.vue';
import UploadPhotos from '../components/UploadPhotos.vue';
export default {
    components: { DescriptionXs, UploadPhotos },
};
</script>

<style lang="scss" scoped></style>
